<script>
import { Line } from 'vue-chartjs'

const brandInfo = '#1957CD'

export default {
  extends: Line,
  props: ['height', 'apiData', 'chartName'],
  computed: {
    chartData: function () {
      // console.log(this.values)
      return this.values
    },
    labels: function () {
      const labels = this._.map(this.apiData, 'timeInterval')
      return labels
    },
    values: function () {
      const values = this._.map(this.apiData, 'count')
      return values
    },
    maxYAxis: function () {
      return this._.reduce(this.apiData, function (result, value) {
        return value.count > result ? value.count : result
      }, 0)
    }
  },
  data: function () {
    return {

    }
  },
  methods: {
    renderLineChart: function () {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: this.chartName,
            backgroundColor: '#ffffff',
            borderColor: brandInfo,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 4,
            data: this.chartData,
            lineTension: 0,
            pointRadius: 2
          }
        ]
      }, {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: Math.ceil(250 / 3),
              max: this.maxYAxis
            },
            gridLines: {
              display: false
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      })
    }
  },
  watch: {
    apiData: function () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }

      this.renderLineChart()
    }
  },
  mounted () {
    this.renderLineChart()
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/charts/MainChart.vue